/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：699__part-0
 */

"use strict"

import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
import /* 50 */"../../../50/index"
import * as /* [auto-meaningful-name] */Module_278 from /* 278 */"../../278"
import * as /* [auto-meaningful-name] */Module_98 from /* 98 */"../98"
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../../../19"
import * as /* [auto-meaningful-name] */Module_54 from /* 54 */"../../../54"
import * as /* [auto-meaningful-name] */Module_1065 from /* 1065 */"./1065"
import * as /* [auto-meaningful-name] */Module_709 from /* 709 */"../709/index"
import * as /* [auto-meaningful-name] */Module_690 from /* 690 */"../../../552/1214/690/index"
import * as /* [auto-meaningful-name] */Module_154 from /* 154 */"./154/index"
import * as /* [auto-meaningful-name] */Module_316 from /* 316 */"../../../552/1214/316/index"
import * as /* [auto-meaningful-name] */Module_2642 from /* 2642 */"./2642/index"
import * as /* [auto-meaningful-name] */Module_2679 from /* 2679 */"./2679"
import * as /* [auto-meaningful-name] */Module_103 from /* 103 */"../../../103"
import * as /* [auto-meaningful-name] */Module_106 from /* 106 */"../../../106"
import * as /* [auto-meaningful-name] */Module_388 from /* 388 */"../../../388"
import * as /* [auto-meaningful-name] */Module_362 from /* 362 */"../../../362"
import * as /* [auto-meaningful-name] */Module_120 from /* 120 */"../../../120"
import * as /* [auto-meaningful-name] */Module_1005 from /* 1005 */"./1005"
import * as /* [auto-meaningful-name] */Module_2683 from /* 2683 */"./2683/index"
import * as /* [auto-meaningful-name] */Module_339 from /* 339 */"../../../339"
import * as /* [auto-meaningful-name] */Module_434 from /* 434 */"../../../434"
function C(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "")
}
export { C }
